import { ReactNode, useMemo } from 'react'

import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { StockMove } from '@/interfaces/warehouse/StockMove'
import { cn } from '@/lib/utils'

import { StockMoveRow } from './StockMoveRow'

interface StockMovesProps {
  stockMoves: StockMove[] | undefined
  isLoading?: boolean
  emptyMessage?: ReactNode
  showSku?: boolean
  showWarehouse?: boolean
  limit?: number
}

/** Historie pohybů: typ, změna se znaménkem, stav po pohybu, důvod, datum. Nejnovější nahoře. */
export const StockMoves = ({
  stockMoves,
  isLoading,
  emptyMessage,
  showSku = true,
  showWarehouse = false,
  limit,
}: StockMovesProps) => {
  const sorted = useMemo(() => {
    const list = [...(stockMoves ?? [])].sort((a, b) => (b.createdAt ?? '').localeCompare(a.createdAt ?? ''))
    return limit ? list.slice(0, limit) : list
  }, [stockMoves, limit])

  return (
    <div className="overflow-hidden rounded-lg border">
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead className={cn('w-40', showSku && 'hidden md:table-cell')}>Datum</TableHead>
            {showSku && <TableHead>Položka</TableHead>}
            {showWarehouse && <TableHead className="hidden w-48 md:table-cell">Sklad</TableHead>}
            <TableHead className="hidden w-28 md:table-cell">Typ</TableHead>
            <TableHead className="w-24 text-right">Změna</TableHead>
            <TableHead className="hidden w-24 text-right md:table-cell">Po pohybu</TableHead>
            <TableHead className="hidden md:table-cell">Důvod</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading &&
            Array.from({ length: 5 }).map((_, index) => (
              <StockMoveRow key={index} showSku={showSku} showWarehouse={showWarehouse} />
            ))}
          {!isLoading &&
            sorted.map((stockMove) => (
              <StockMoveRow key={stockMove.id} stockMove={stockMove} showSku={showSku} showWarehouse={showWarehouse} />
            ))}
        </TableBody>
      </Table>
      {!isLoading && sorted.length === 0 && (
        <p className="px-4 py-10 text-center text-sm text-muted-foreground">{emptyMessage ?? 'Zatím žádné pohyby.'}</p>
      )}
    </div>
  )
}
